import React, { useState, useEffect } from 'react';
import LoginPage from './LoginPage';
import Home from './Home';

function App() {
  const [currentPage, setCurrentPage] = useState('login');

  useEffect(() => {
    const isLoggedIn = localStorage.getItem('isLoggedIn');
    if (isLoggedIn === 'true') {
      setCurrentPage('home');
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('userEmail');
    setCurrentPage('login');
  };

  return (
    <>
      {currentPage === 'login' && (
        <LoginPage setCurrentPage={setCurrentPage} />
      )}
      {currentPage === 'home' && (
        <Home onLogout={handleLogout} />
      )}
    </>
  );
}

export default App;
